var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeasuringTape(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 38,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M.933 6.41s-.056 16 0 23.64c.059 7.638 14.256 6.87 14.256 6.87h34.533V13.218H18.185c-4.29 0-17.276-.963-17.276-6.806S16.279.955 16.279.955 31.132.4 32.307 6.41c.663 3.392-3.32 6.323-8.785 6.806"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M13.943 28.08v8.308m9.43-12.738v12.738m8.875-8.308v8.308m8.875-12.738v12.738"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.213 5.926c0 .61-1.118 1.108-2.496 1.108-1.38 0-2.496-.497-2.496-1.108 0-.613 1.116-1.108 2.496-1.108 1.378 0 2.496.495 2.496 1.108z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M32.248 6.756v6.37"
  })));
}
export default SvgMeasuringTape;